import(/* webpackMode: "eager", webpackExports: ["AlternativeCollection"] */ "/vercel/path0/src/components/alternativeCollection/alternativeCollection.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternativeContent"] */ "/vercel/path0/src/components/alternativeContent/alternativeContent.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlternativesHero"] */ "/vercel/path0/src/components/alternativesHero/alternativesHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/src/components/faq/faq.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/vercel/path0/src/components/numbers-and-reviews/reviews/reviews.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBy"] */ "/vercel/path0/src/components/trustedBy/trustedBy.comp.tsx");
